<script setup lang="ts">
import {reactive} from "vue";
import axios, {AxiosError} from "axios";
import {Button, InputText, Label, Password} from "@/Components/Library";
import {useRouter} from "vue-router";
import {logIn as authLogin} from "@/Services/auth";
import {useMainStore} from "@/Stores/store";

const $store = useMainStore();
const router = useRouter();

const state = reactive({loading: false});
const credentials = reactive({
    email: "",
    password: "",
    remember: true,
});

const csrfCookie = async () => {
    try {
        const resp = await axios.get("/sanctum/csrf-cookie");
        console.log(resp);
    } catch (e) {
        console.log(e);
    }
};
csrfCookie();

// authUser().then((data) => {
//     console.log("authUser data", data);
//     if (data.id) {
//         sessionStorage.setItem("user", data.id);
//         $store.user = data;
//         router.push("/");
//     }
// });

const logIn = async () => {
    try {
        state.loading = true;
        const data = await authLogin(credentials);
        sessionStorage.setItem("user", data.id);
        $store.user = data;
        try {
            await router.push(sessionStorage.getItem("intended") || "/");
        } catch (e) {
            console.log(e);
        } finally {
            sessionStorage.removeItem("intended");
        }
    } catch (e: AxiosError | any) {
        console.log(e);
        // alert(e.response.data.message ?? "An error occurred");
    } finally {
        state.loading = false;
    }
};
</script>
<template>
    <div>
        <!--        <div class="flex justify-center gap-4">-->
        <!--            <router-link :to="{name: 'login'}" class="mb-4 border-b-2 border-white px-3 pb-1 text-xl font-bold">-->
        <!--                Log In-->
        <!--            </router-link>-->
        <!--            <router-link :to="{name: 'register'}" class="mb-4 px-3 pb-1 text-xl font-bold">Sign up</router-link>-->
        <!--        </div>-->
        <h3 class="mb-4 text-2xl font-bold">Log in</h3>
        <form @submit.prevent="logIn">
            <div class="mb-4">
                <Label for="email" class="mb-1">Email</Label>
                <InputText
                    class="!border-stone-300 !bg-transparent text-white placeholder:!text-stone-400"
                    id="email"
                    name="email"
                    type="email"
                    placeholder="Email"
                    fluid
                    v-model="credentials.email"
                />
            </div>
            <div class="mb-4">
                <Label for="password" class="mb-1">Password</Label>
                <Password
                    inputId="password"
                    name="password"
                    placeholder="Password"
                    fluid
                    toggleMask
                    :feedback="false"
                    inputClass="!border-stone-300 !bg-transparent text-white placeholder:!text-stone-400"
                    v-model="credentials.password"
                />
            </div>
            <!-- remember me -->
            <!--            <div class="mb-4 flex gap-2">-->
            <!--                <Checkbox v-model="credentials.remember" binary input-id="remember" />-->
            <!--                <label for="remember">Remember me</label>-->
            <!--            </div>-->
            <div class="mb-16 flex flex-col items-center gap-3">
                <Button
                    type="submit"
                    :loading="state.loading"
                    icon="lucide:unlock"
                    class="rounded bg-askr-green-500 text-white hover:brightness-110"
                >
                    Sign in
                </Button>
                <RouterLink to="/forgot-password">Forgot password?</RouterLink>
            </div>
        </form>
    </div>
</template>
<style scoped></style>
